// EmployeeDashboard/ConfirmationModal.js

import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const ConfirmationModal = ({ open, handleConfirm, handleClose, title, message }) => {
 

  const modalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
    textAlign:"center",
    border: 'none', // Remove the border
  };

  return (
    
    <Box sx={styles.formbox}>
           
            <Modal open={open} onClose={handleClose}>
              <Box sx={modalStyles}>
              
                <Typography variant="h6" component="h2">
          {title}
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {message}
        </Typography>
                <Box sx={{ display: 'flex', mt: 2, justifyContent: 'center' }}>
                  <Button variant="contained" color="primary"  sx={{
    margin: "4px",
    textTransform: "none",
    backgroundColor: "black",
    "&:hover": {
      backgroundColor: "black", // Change to the desired hover color
    },
  }} onClick={handleConfirm}>
                    Yes
                  </Button>
                  <Button  sx={{
    margin: "4px",
    textTransform: "none",
    backgroundColor: "black",
    "&:hover": {
      backgroundColor: "black", // Change to the desired hover color
    },
  }} variant="contained" onClick={handleClose}>
                    No
                  </Button>
                </Box>
              </Box>
            </Modal>
          </Box>
  );
};

export default ConfirmationModal;

const styles = {
    formbox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "35px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "120px",
      width: "380px",
      backgroundColor: "light gray",
     
    },
    formboxres: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "35px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "350px",
      width: "290px",
      backgroundColor: "light gray",
     
    },
  };
